import React from 'react';
import {useHistory} from 'react-router-dom';
import noAvatar from '../../assets/images/no-avatar.png';
import editIcon from '../../assets/images/edit_icon.png';
import { GET_USER_POINTS_QUERY, GET_USER_CERTIFICATES_QUERY, GET_MY_CAMPAIGNS_QUERY } from "queries/queries";
import { useQuery } from "@apollo/client";
import Loading from 'components/loading';
import Error from 'components/error';

const Teaser = ({ user }) => {
  let history = useHistory();
  const url = user.avatarUrl || noAvatar;
  console.log('url', url)
  const { loading, error, data } = useQuery(GET_USER_POINTS_QUERY, {
    fetchPolicy: "no-cache"
  });

  const { data: certData } = useQuery(GET_USER_CERTIFICATES_QUERY, {
    fetchPolicy: "no-cache"
  });

  const myCouponsResult = useQuery(GET_MY_CAMPAIGNS_QUERY, {
    fetchPolicy: "no-cache",
  });

  if (loading) return <Loading/>;
  if (error) return <Error/>;

  const points = data?.statistics?.availablePoints;
  const certificates = certData?.statistics?.certificates?.length ?? 0;

  return (
    <div className='profile-teaser'>
      <div className="teaser-avatar-container">
      </div>
      <div className='teaser-trainer-container'>
        <div className="teaser-trainer-info">
        <div className="teaser-trainer-name">{`${user.firstName} ${user.lastName}`}</div>
        <div className="teaser-trainer-region">{user.email}</div>
        </div>
        <div>
          <div className='points-badge'>
            <img 
              src={editIcon}
              onClick={e => {
                e.preventDefault();
                history.push(`/edit_profile`);
              }}
              className='points-badge-icon'
            />
          </div>
        </div>
      </div>
        <div className='teaser-buttons'>
      </div>
      <div className='teaser-items'>
        <div className='teaser-item'>
          <span className='teaser-item-title'>Punkte</span>
          <div className='teaser-item-value'>{points}</div>
        </div>
        <div className='teaser-item'>
          <span className='teaser-item-title'>Zertifikate</span>
          <div className='teaser-item-value'>{certificates}</div>
        </div>
        <div className='teaser-item'>
          <span className='teaser-item-title'>Coupons</span>
          <div className='teaser-item-value'>{myCouponsResult.length ?? 0}</div>
        </div>
      </div>
    </div>
  );
};

export default Teaser;
